import React from 'react';
import { motion } from 'framer-motion';
export const Header = () => {
  return <header className="w-full flex justify-start items-center py-3 sm:py-4 px-4 sm:px-6" data-id="element-98">
      <motion.div className="bg-white rounded-full px-4 py-2 sm:px-5 sm:py-2.5 shadow-md" initial={{
      opacity: 0,
      y: -10
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.5,
      ease: 'easeOut'
    }} data-id="element-99">
        <img src="https://cdn.magicpatterns.com/uploads/2auLJdy6xLg1o4H31DuoBi/Layer_x0020_1_(3).png" alt="HIRE Logo" className="h-[1.75rem] sm:h-[2.25rem]" data-id="element-100" />
      </motion.div>
    </header>;
};